<template>
<div class="home">
  <h2>Welcome to Our Site Index</h2>
  <keep-alive>
    <HomeContent />
  </keep-alive>
</div>
</template>

<script>
// @ is an alias to /src
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'Home',
  components: {
    HomeContent: () => import( /* webpackChunkName: "HomeContent" */ '@/components/HomeContent.vue')
  },
  data() {
    return {
      loading: true
    };
  },
}
</script>

<style>
.home {
  background-image: url(../assets/draft_bg-1.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  /*border: 2px solid #e9385a;*/
}

#noBackground {
  background: none;
}
</style>
